import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { ExportDocumentsService } from '../../service/export-documents.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-export-document-select',
  templateUrl: './export-document-select.component.html',
  styleUrls: ['./export-document-select.component.scss']
})
export class ExportDocumentSelectComponent implements OnInit, OnChanges, OnDestroy {

  constructor(private exportDocumentsService:ExportDocumentsService) { }

  @Input() documentId:string;
  isSelected:boolean;
  private ngUnsubscribe = new Subject<void>();

  ngOnInit(): void {
    this.subscribeExportState();
  }

  ngOnChanges(): void {
    this.subscribeExportState();
  }

  subscribeExportState(){
 this.exportDocumentsService.selectedDocs$
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(
      () => this.isSelected = this.exportDocumentsService.containsDocument(this.documentId)
    );
  }

  selectionChange(ev:boolean){
    if(ev){
      this.exportDocumentsService.addDocument(this.documentId);
    }
    else{
      this.exportDocumentsService.removeDocument(this.documentId);
    }
   
    this.isSelected = this.exportDocumentsService.containsDocument(this.documentId);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
